import { postInitBookingService } from "api.service";
import { ISelectedArrangements } from "components/StayCardPricesTable/StayCardPricesTable";
import { DisplaySideBarBody } from "containers/ListingDetailPage/DisplaySideBarBody";
import { useSearch } from "context/SearchContext";
import { useSearchResultFn } from "hooks/useSearchApi";
import { IPostInitBookingServiceParams } from "interfaces/booking";
import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { calculateStayTotalPrice } from "utils/prices.utils";

export interface Step3Props {
  handleStepChange: () => void;
  selectedArrangements: ISelectedArrangements;

  selectedRooms: {
    [roomIndex: number]: number;
  };
}

const Step3: React.FC<Step3Props> = ({
  handleStepChange,
  selectedRooms,
  selectedArrangements,
}) => {
  const { searchResult, searchData, userType } = useSearch();
  const { hotelSlug }: { hotelSlug: string } = useParams();
  const initBookingService = useSearchResultFn(postInitBookingService);
  const history = useHistory();
  console.log(history, "history");
  const isOverBooked = useMemo(() => {
    return searchResult?.occupancies.reduce(
      (acc: any, val: any, index: any) => {
        const room = val.room_types.find(
          (el: any) => el.data.id === selectedRooms[index]
        );
        if (acc) return acc;
        if (!room) return true;
        if (!room.immediate_booking) return true;
        if (room.rate_type === "onrequest") return true;
        if (room?.quantity === 0 || room?.stop_sale) return true;
        return false;
      },
      false
    );
  }, [selectedRooms]);

  const isStopStale = useMemo(() => {
    return searchResult?.occupancies.reduce(
      (acc: any, val: any, index: any) => {
        const room = val.room_types.find(
          (el: any) => el.data.id === selectedRooms[index]
        );
        if (acc) return acc;
        if (!room) return true;
        if (room.rate_type === "stop_sale") return true;
        if (room?.stop_sale) return true;
        return false;
      },
      false
    );
  }, [selectedRooms]);

  const handleInitBooking = async () => {
    const reservation: IPostInitBookingServiceParams = {
      hotel: hotelSlug,
      start_date: searchData.dateRange.startDate?.format("YYYY-MM-DD") || "",
      end_date: searchData.dateRange.endDate?.format("YYYY-MM-DD") || "",
      currency: searchData.currency,
      occupancies: searchData.rooms.reduce((acc: any, val, index) => {
        const occupancy = {
          adult: val.guestAdults,
          child: String(val.guestChildren.length),
          child_ages: val.guestChildren,
          room_id: String(selectedRooms[index]),
          board_id: String(
            selectedArrangements[index][selectedRooms[index]].boardId
          ),
        };

        acc.push(occupancy);
        return acc;
      }, []),
    };

    await initBookingService.execute(reservation).then((res: any) => {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("checkoutSlug", res.slug);
      history.push(`${currentUrl.pathname}${currentUrl.search}`);
    });

    handleStepChange();
  };

  const calculateTotalPrice = () => {
    // debugger;
    return calculateStayTotalPrice(
      userType!,
      searchResult?.occupancies!,
      selectedRooms,
      selectedArrangements
    );
  };

  return (
    <div className="flex flex-col justify-center w-1/2 mx-auto">
      <DisplaySideBarBody
        hotel={searchResult!}
        selectedArrangements={selectedArrangements}
        selectedRooms={selectedRooms}
      />

      {searchResult &&
        !(
          searchResult?.occupancies.length === 1 &&
          searchResult?.occupancies[0].room_types.length === 0
        ) && (
          <>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            <div className="flex justify-between items-center">
              <div className="text-lg font-bold mb-2">Total</div>
              <div className="flex items-end flex-col">
                {calculateTotalPrice().price_without_promotion !==
                  calculateTotalPrice().price && (
                  <div className="text-red-600 text-sm line-through">
                    {calculateTotalPrice().price_without_promotion}{" "}
                    {searchData?.currency}
                  </div>
                )}
                <div className="font-bold text-xl">
                  {calculateTotalPrice().price} {searchData?.currency}
                </div>
              </div>
            </div>
          </>
        )}

      {!isStopStale && searchResult && (
        <div className="flex justify-end mt-5">
          <ButtonPrimary
            className="rounded-none !bg-[#aa8453] w-36"
            onClick={handleInitBooking}
            loading={initBookingService.loading}
          >
              Continuer
          </ButtonPrimary>
        </div>
      )}
    </div>
  );
};

export default Step3;
